/* eslint-disable @next/next/no-img-element */
import { useEffect, useRef, useState } from 'react';
import Styles from './SearchableDropdown.css';

function SearchableDropdownV2({
  options,
  label,
  id,
  error,
  completed,
  optionsContainerId,
  handleBlur,
  onValueChanged,
  ...props
}) {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', toggle);
    return () => document.removeEventListener('click', toggle);
  }, []);

  const selectOption = (option) => {
    setSelected(option[label]);
    setIsOpen(false);
    setQuery('');
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    return query || selected;
  };

  const filter = (options) => {
    return options.filter(
      (option) => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1,
    );
  };

  useEffect(() => {
    if (onValueChanged) {
      onValueChanged(selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  useEffect(() => {
    if (!query) {
      return;
    } else {
      setIsOpen(true);
    }

    const match = options.find((o) => String(o[label]).toLowerCase().includes(query.toLowerCase()));
    if (!match) {
      setSelected('');
      return;
    }

    setSelected(match[label]);
  }, [label, options, query]);

  // useEffect(() => {
  //   console.log({ query, selected });
  // }, [query, selected]);

  return (
    <>
      <div className="dropdown">
        <div className="control">
          <div className="selected-value">
            <input
              {...props}
              autoComplete="off"
              ref={inputRef}
              type="text"
              value={getDisplayValue()}
              onChange={(e) => {
                const val = e.target.value;

                if (!val) {
                  setSelected('');
                }

                setQuery(val);
              }}
              onBlur={(ev) => {
                if (typeof handleBlur === 'function') {
                  handleBlur(ev);
                }
              }}
              onClick={toggle}
              placeholder={props.placeholder}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                  if (!!selected) {
                    setQuery('');
                    setIsOpen(false);
                  }
                }
              }}
            />
          </div>
          <div className={`arrow ${isOpen ? 'open' : ''}`} />
        </div>

        <div className={`options ${isOpen ? 'open' : ''}`} id={optionsContainerId}>
          {filter(options).map((option, index) => {
            return (
              <div
                onClick={(ev) => {
                  ev.preventDefault();
                  selectOption(option);
                }}
                className={`option ${option[label] === selected ? 'selected' : ''}`}
                key={`${id}-${index}-${option[label]}`}
              >
                {option[label]}
              </div>
            );
          })}
        </div>
      </div>

      {error && <p className="input-error-text">*{error}</p>}

      <style jsx>{Styles}</style>
    </>
  );
}

export default SearchableDropdownV2;
